import React from 'react';

import Post from '../shared/Post/Post';
import ScaleContent from '../shared/ScaleContent/ScaleContent';
import './PostType.scss';
import PostTypeSlider from './PostTypeSlider/PostTypeSlider';

export default function PostType() {
  return (
    <div className="post-type" data-testid="postType">
      <PostTypeSlider />
      <ScaleContent
        // eslint-disable-next-line react/no-unstable-nested-components
        content={({styles}) => {
          return <Post beers={[]} style={styles} />;
        }}
      />
    </div>
  );
}
